<script setup>
// The SHAPE half of every status (D6, WCAG 1.4.1): colour is never the sole
// carrier of meaning. Shapes are ported exactly from the locked status
// taxonomy reference. currentColor inherits the chip's text colour.
//   unconfirmed ● filled dot   confirmed ◇ hollow diamond
//   pending     ◔ half-ring    approved  ✓ tick
//   rejected    ✕ cross        notreq    ○ hollow dot
defineProps({
  state: { type: String, required: true },
})
</script>

<template>
  <svg
    v-if="state === 'unconfirmed'"
    class="shape" width="9" height="9" viewBox="0 0 9 9" aria-hidden="true"
  >
    <circle cx="4.5" cy="4.5" r="3.5" fill="currentColor" />
  </svg>

  <svg
    v-else-if="state === 'confirmed'"
    class="shape" width="9" height="9" viewBox="0 0 9 9" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"
  >
    <path d="M4.5 1.2 7.8 4.5 4.5 7.8 1.2 4.5z" />
  </svg>

  <svg
    v-else-if="state === 'pending'"
    class="shape" width="9" height="9" viewBox="0 0 9 9" aria-hidden="true"
  >
    <circle cx="4.5" cy="4.5" r="3.6" fill="none" stroke="currentColor" stroke-width="1.4" />
    <path d="M4.5 .9a3.6 3.6 0 010 7.2z" fill="currentColor" />
  </svg>

  <svg
    v-else-if="state === 'approved'"
    class="shape" width="9" height="9" viewBox="0 0 9 9" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"
  >
    <path d="M1.4 4.8 3.5 6.9 7.6 2.2" />
  </svg>

  <svg
    v-else-if="state === 'rejected'"
    class="shape" width="9" height="9" viewBox="0 0 9 9" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"
  >
    <path d="M2 2l5 5M7 2l-5 5" />
  </svg>

  <svg
    v-else
    class="shape" width="9" height="9" viewBox="0 0 9 9" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"
  >
    <circle cx="4.5" cy="4.5" r="3.3" />
  </svg>
</template>

<style scoped>
.shape {
  flex: none;
}
</style>
